import { FC, useContext, useEffect } from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";

import { Button, Modal } from "components";

import { BUYER_LOGIN_URL, BUYER_SIGNUP_URL } from "../../constants";
import { AppContext } from "../../contexts";

const useStyles = makeStyles(theme => ({
  actions: {
    padding: theme.spacing(1.875, 0),
    "& > :not(:last-child)": {
      marginBottom: theme.spacing(1.875),
    },
  },
}));

interface LogInRequiredModalProps {
  open: boolean;
  onClose: (e?: any) => void;
}

const LogInRequiredModal: FC<LogInRequiredModalProps> = ({ open, onClose }) => {
  const classes = useStyles();
  const { screenType } = useContext(AppContext);

  useEffect(() => {
    const rootEl = document.getElementById("react-root");
    if (rootEl && open) {
      rootEl.style.filter = "blur(10px)";
      return () => {
        rootEl.style.filter = "";
      };
    }
  }, [open]);

  return (
    <Modal
      title="Log In Required"
      open={open}
      onClose={onClose}
      onClick={e => {
        e.stopPropagation();
      }}
    >
      <Typography component="div" gutterBottom>
        This action is restricted to Royalty Exchange users. Please log in or
        create a free account.
      </Typography>
      <Box className={classes.actions}>
        <Button
          customColor="green"
          size="large"
          variant="contained"
          fullWidth
          component={Link}
          to={`${BUYER_LOGIN_URL}?next=${window.location.pathname}`}
        >
          Log In
        </Button>

        <Button
          customColor="gray"
          variant="contained"
          size="large"
          fullWidth
          component={Link}
          to={`${BUYER_SIGNUP_URL}?next=${window.location.pathname}`}
        >
          {screenType === "mobile" ? "Create Account" : "Create Free Account"}
        </Button>
      </Box>
    </Modal>
  );
};

export default LogInRequiredModal;
